import { Link } from "react-router-dom";
import {
  renderCustomColumnDefs,
  renderValidations,
} from "../../shared/Table/table.utils";
import { statusOptions } from "../../constants/select";
import { formatDate, renderAmount } from "../../utils";
import { hasStoredPermission } from "../../utils/authority";
import { PERMISSIONS } from "../../constants/access-control";
import { getProductTerminology } from "../../constants/product-terminology";

const canEditInvoices = () => hasStoredPermission(PERMISSIONS.INVOICES_EDIT);

/**
 * Invoice list columns. Jobs header follows tenant terminology.
 * @param {string} [appType]
 */
export const getInvoiceTableConfig = (appType) => {
  const terms = getProductTerminology(appType);
  return [
    {
      id: "invoiceId",
      header: "Invoice ID",
      visible: true,
      editable: canEditInvoices(),
      cell: ({ row: { original }, getValue }) => {
        return (
          <Link
            className="text-primary-600 hover:underline"
            to={`/invoices/${original._id}`}
          >
            {getValue()}
          </Link>
        );
      },
    },
    {
      id: "status",
      cell: ({ getValue }) => {
        const value = getValue();
        return value;
      },
      editable: {
        type: "select",
        options: statusOptions,
        disabled: !canEditInvoices(),
      },
    },
    {
      id: "dueDate",
      header: "Due Date",
      visible: true,
      cell: ({ getValue }) => {
        return formatDate(getValue(), null, true);
      },
    },
    {
      id: "jobs",
      header: terms.jobPlural,
      cell: ({ getValue }) => {
        return getValue().length;
      },
    },
    {
      id: "client",
      visible: true,
      cell: ({ getValue }) => getValue()?.name,
    },
    {
      id: "total",
      visible: true,
      cell: ({ getValue, row }) => {
        const invoice = row.original;
        return renderAmount(invoice.calculatedTotalCharges || getValue() || 0);
      },
    },
    {
      id: "dateUpdated",
      visible: false,
      cell: ({ getValue }) => {
        return formatDate(getValue(), null, true);
      },
    },
    {
      id: "dateCreated",
      header: "Date Created",
      visible: false,
      cell: ({ getValue }) => {
        return formatDate(getValue(), null, true);
      },
    },
    {
      id: "author",
      visible: false,
      cell: ({ getValue }) => getValue().fullName,
    },
    {
      id: "_id",
      header: "id",
      visible: false,
      width: 230,
    },
  ];
};

export const getColumnDefinitions = (appType) =>
  renderCustomColumnDefs(getInvoiceTableConfig(appType));

export const FORM_OPTIONS = {
  validations: renderValidations(getInvoiceTableConfig()),
};
export const PAGE_SIZE_OPTIONS = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "150", value: 150 },
];
